import React from "react"
import { MDBCol, MDBContainer, MDBRow, MDBFooter } from "mdbreact"
import logo from "../images/logo.png"

const Footer = () => {
  return (
    <MDBFooter
      color="elegant-color-dark"
      className="font-small pt-4 container-fluid pb-3"
    >
      <MDBContainer className="text-center text-md-left pb-4">
        <MDBRow>
          <MDBCol md="6">
            <img src={logo} alt="" height="30px" />
          </MDBCol>
        </MDBRow>
      </MDBContainer>
      <MDBContainer>
        <MDBRow between>
          <MDBCol size="auto" className="mx-auto mx-md-0">
            &copy; {new Date().getFullYear()} Dominion Enterprises. All rights
            reserved.{" "}
          </MDBCol>
          <MDBCol size="auto" className="mx-auto mx-md-0">
            <a href="https://www.dominionenterprises.com/privacy/">
              Privacy Policy
            </a>
            &nbsp;&nbsp;|&nbsp;&nbsp;
            <a href="https://www.dominionenterprises.com/terms-of-use/">
              Terms of Service
            </a>
          </MDBCol>
        </MDBRow>
      </MDBContainer>
    </MDBFooter>
  )
}

export default Footer
